import Alert from "../Alert";

const liveAgentWhatsappNumberException1 =
    process.env.REACT_APP_LIVE_AGENT_WHATSAPP_NUMBER_EXCEPTION_1?.trim();

const AccountVerificationPopup = ({ isOpen, onClose, onChat, title = "" }) => {
  return (
    <Alert
      title={title || "Account Verification"}
      description="Thank you for submitting your information. We need to perform further verification to activate your account."
      isOpen={isOpen}
      isCS="https://principal.com.my"
      isCancel={false}
      btnTxt="Chat with us on WhatsApp"
      handleAction={() => {
        onChat();
        window.my.call("openAppLink", {
          url: `https://wa.me/${liveAgentWhatsappNumberException1}` ,
        });
      }}
      handleCancel={onClose}
    />
  );
};

export default AccountVerificationPopup;
